import type { SnakeCasedPropertiesDeep } from "type-fest";

export interface AssetJobNotificationData {
    jobUuid?: string;
    groupName?: string;
    totalRequestedAssets?: number;
    totalSucceededAssets?: number;
    totalFailedAssets?: number;
}

type AssetJobNotificationDataDto = SnakeCasedPropertiesDeep<AssetJobNotificationData>;

export function parseAssetJobNotificationData(data: string | undefined): AssetJobNotificationData {
    try {
        const dto: AssetJobNotificationDataDto = JSON.parse(data ?? "");
        return {
            jobUuid: dto.job_uuid,
            groupName: dto.group_name,
            totalRequestedAssets: dto.total_requested_assets,
            totalSucceededAssets: dto.total_succeeded_assets,
            totalFailedAssets: dto.total_failed_assets,
        };
    } catch {
        return {};
    }
}
